<template>
    <div class="header-navigation-wrapper">
        <base-header-navigation
                ref="baseHeaderNavigation"
                class="header-navigation"
                :offset="offset"
                :scroll-offset="scrollOffset"
                :value="value"
                :menu-items="menuItems"
                @input="menuItem => $emit('input', menuItem)">
        </base-header-navigation>
        <div class="menu-pin" :style="menuPinStyles"></div>
    </div>
</template>

<script>
    import { HeaderNavigation as BaseHeaderNavigation } from "@rawlplug/ldp-components";

    export default {
        components: {
            BaseHeaderNavigation,
        },
        data() {
            return {
                currentLeft: 0
            }
        },
        props: {
            menuItems: {
                type: Array,
                required: true
            },
            value: {
                required: true
            },
            offset: {
                type: Number,
                default: 220
            },
            scrollOffset: {
                default: 190
            }
        },
        mounted() {
            this.calculateCurrentLeft();
        },
        methods: {
            calculateCurrentLeft() {
                let activeElement;
                if (this.value) {
                    activeElement = document.querySelector(`a[href="${this.value.href}"]`);
                } else {
                    activeElement = document.querySelector(`.header-navigation a[href]`);
                }
                if (activeElement) {
                    const rectElement = activeElement.getBoundingClientRect();
                    const topMenuDecorWidth = 14;
                    this.currentLeft = parseInt(rectElement.left + rectElement.width / 2 - topMenuDecorWidth);
                } else {
                    this.currentLeft = 0;
                }
            }
        },
        computed: {
            menuPinStyles() {
                return {
                    'left': `${this.currentLeft}px`
                }
            },
        },
        watch: {
            value() {
                this.calculateCurrentLeft()
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@rawlplug/rawlplug-design-style-tokens/dist/scss/all";

    .header-navigation-wrapper {
        width: 100%;

        /**
        ::v-deep {
            .header-navigation__item a.is-active {
                &::after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    height: 3px;
                    background-color: $color-rwl-orange-100;
                    transform: translateY(1px);
                }
            }
        }
         */

        .header-navigation {
            width: 100%;
            justify-content: space-between;
        }
    }



    .menu-pin {
        transition: left 300ms linear;
        position: absolute;
        top: 100%;
        left: 0;
        width: 0;
        height: 0;
        border-left: 14px solid transparent;
        border-right: 14px solid transparent;
        border-top: 15px solid $color-rwl-blue-20;
        z-index: 90;
    }
</style>
